// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3jMKF","insightsList":"newBusinessInsightsMenu_insightsList__YCULl","active":"newBusinessInsightsMenu_active__2TsNI"};